import DocumentFooterView from "./DocumentFooterView";

export default DocumentFooterView;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/DocumentFooterView/index.js